import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "text-center text-3xl" }
const _hoisted_2 = { class: "w-[100%] h-[100%] grid lg:grid-cols-2 sm:grid-cols-1 gap-4" }
const _hoisted_3 = { class: "shadow shadow-blue-500/50 border-2" }
const _hoisted_4 = { class: "w-[100%] p-2" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "relative overflow-x-auto" }
const _hoisted_7 = { class: "w-[100%] text-sm flex-wrap text-left text-gray-500 dark:text-gray-400" }
const _hoisted_8 = { class: "text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" }
const _hoisted_9 = {
  scope: "col",
  class: "px-6 py-3"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = {
  scope: "col",
  class: "px-6 py-3"
}
const _hoisted_12 = {
  scope: "col",
  class: "px-6 py-3"
}
const _hoisted_13 = { class: "px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "shadow shadow-blue-500/50 border-2" }
const _hoisted_17 = { class: "w-[100%] p-2" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "w-[100%] text-sm flex-wrap text-left text-gray-500 dark:text-gray-400" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("thead", { class: "text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3"
    }, "Data"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3"
    }, "Mittente"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3"
    }, "Messaggio")
  ])
], -1)
const _hoisted_21 = { class: "px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white" }
const _hoisted_22 = ["innerHTML"]

import CardComponent from "@/components/shared/element/cardComponent.vue";
import { useCustomerStore } from "@/stores/customer";
import { onMounted, PropType, Ref, ref, toRaw, toRef, UnwrapRef } from "vue";
import * as dashboardService from "@/services/dashboard/dashboardService";
import { format } from 'date-fns';
import AppPdfModal from "@/components/pdf/PdfViewer.vue";
import { useVfm } from "vue-final-modal";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const vfm = useVfm();

const store = useCustomerStore();

const customer: any = toRaw(store.customer);
const documents: Ref<UnwrapRef<any[]>> = ref([]);
const comunications: Ref<UnwrapRef<any[]>> = ref([]);

const strPdf = ref('');

const getPdf = async (doc: any) => {
  const datToSend = {
    namefile: doc.nomeDocumento,
    pathfile: doc.percorsofile
  }

  const res = await dashboardService.getPdfDocument(datToSend);
  return arrayBufferToBase64(res);
}

function arrayBufferToBase64(buffer: ArrayBuffer): string {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

const openModal = async (doc: any) => {
  strPdf.value = await getPdf(doc);
  await vfm.open('appPdfModal-'+doc.id);
  //await vfm.open('modalIdPdf-' + doc.id);
}

const formatDate = (str_date: string) => {
  return format(new Date(str_date), 'dd-MM-yyyy');
}

const docs = async () => {
  documents.value = await dashboardService.getDocuments(customer?.codiceRapporto);
}

const coms = async () => {
  comunications.value = await dashboardService.getComunications({'customer':customer?.id});
}


onMounted( () =>{
    docs();
    coms();
  }
);


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h4", _hoisted_1, _toDisplayString(_ctx.$t('home.dashboard')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(CardComponent, null, {
            title_card: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('home.last_docs')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _createElementVNode("thead", _hoisted_8, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_9, [
                    _createTextVNode(_toDisplayString(_ctx.$t('table_docs.header.date_doc')), 1),
                    _hoisted_10,
                    _createTextVNode(_toDisplayString(_ctx.$t('table_docs.header.contract_no')), 1)
                  ]),
                  _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('table_docs.header.description')), 1),
                  _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('table_docs.header.actions')), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documents.value, (doc) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "bg-white border-b dark:bg-gray-800 dark:border-gray-700",
                    key: doc.id
                  }, [
                    _createElementVNode("td", _hoisted_13, [
                      _createTextVNode(_toDisplayString(formatDate(doc?.dataDocumento)), 1),
                      _hoisted_14,
                      _createTextVNode(_toDisplayString(doc?.codiceRapporto), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(doc?.descrizioneProdotto), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("a", {
                        class: "block border-1 bg-regal-blue text-white text-center p-2 rounded-[2.5rem] hover:underline hover:bg-regal-cyan hover:cursor-pointer",
                        onClick: ($event: any) => (openModal(doc))
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "fa-solid fa-file-pdf",
                          class: "text-white px-2"
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('table_docs.rows.show')), 1)
                      ], 8, _hoisted_15)
                    ]),
                    _createVNode(AppPdfModal, {
                      "modal-id": 'appPdfModal-'+doc.id,
                      streamPdf: strPdf.value
                    }, null, 8, ["modal-id", "streamPdf"])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(CardComponent, null, {
            title_card: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('home.last_messages')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("table", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comunications.value, (com) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "bg-white border-b dark:bg-gray-800 dark:border-gray-700",
                  key: com.id
                }, [
                  _createElementVNode("td", _hoisted_21, _toDisplayString(formatDate(com?.createdAt)), 1),
                  _createElementVNode("td", null, _toDisplayString(com?.mittente), 1),
                  _createElementVNode("td", {
                    innerHTML: com?.messaggio
                  }, null, 8, _hoisted_22)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})